const GROUP_BY_ALIASES = {
    hora: 'hour',
    hour_current: 'hour',

    dia: 'day',

    mes: 'month',

    ano: 'year'
};

const VOLUME_MESSAGES = {
    hour: {
        title: 'Volume por hora',
        message: `
            <div class="volume-message">
                <p class="volume-message__title">
                    <strong>Cálculo de volume por hora</strong>
                </p>

                <p>
                    O volume é calculado com base na diferença entre duas medições
                    dentro da mesma hora.
                </p>

                <p>
                    Para que o cálculo seja possível, são necessários no mínimo
                    dois reportes no período (início e fim da hora).
                </p>

                <p>
                    Se houver apenas um reporte na hora, ou intervalos longos de
                    comunicação (ex: 30 minutos ou mais), pode haver diferenças
                    ou impossibilidade de cálculo.
                    Quanto menor o intervalo de reporte, maior a precisão
                    do volume horário.
                </p>
            </div>
        `
    },

    day: {
        title: 'Volume por dia',
        message: `
            <div class="volume-message">
                <p class="volume-message__title">
                    <strong>Cálculo de volume por dia</strong>
                </p>

                <p>
                    O volume diário é calculado com base na diferença entre
                    a primeira e a última medição do dia.
                </p>

                <p>
                    Como o período é maior, normalmente existem múltiplos
                    reportes ao longo do dia, o que torna o cálculo mais
                    consistente e estável em comparação ao cálculo por hora.
                </p>
            </div>
        `
    },

    month: {
        title: 'Volume por mês',
        message: `
            <div class="volume-message">
                <p class="volume-message__title">
                    <strong>Cálculo de volume por mês</strong>
                </p>

                <p>
                    O volume mensal segue a mesma lógica:
                    diferença entre a primeira e a última medição do mês.
                </p>

                <p>
                    Por ser um período maior, é praticamente garantido que
                    existam diversos reportes, tornando o cálculo mais
                    estável e confiável.
                </p>
            </div>
        `
    },

    year: {
        title: 'Volume por ano',
        message: `
            <div class="volume-message">
                <p class="volume-message__title">
                    <strong>Cálculo de volume por ano</strong>
                </p>

                <p>
                    O volume anual é calculado pela diferença entre o acumulado
                    no início e no final do ano.
                </p>

                <p>
                    Por ser um período longo, o cálculo é altamente estável
                    e pouco impactado por falhas curtas de comunicação.
                </p>
            </div>
        `
    },

    mes_dia_especificado: {
        title: 'Volume por Período Específico',
        message: `
            <div class="volume-message">
                <p class="volume-message__title">
                    <strong>Cálculo por Período Específico</strong>
                </p>

                <p>
                    O volume é calculado pela diferença entre a medição
                    do dia selecionado em um mês e a medição
                    do mesmo dia no mês seguinte.
                </p>

                <p>
                    A precisão depende da existência de reportes próximos
                    às duas datas.
                    Como o período é de aproximadamente um mês,
                    o cálculo tende a ser estável.
                </p>
            </div>
        `
    },

    fixo: {
        title: 'Volume por Período Fixo',
        message: `
            <div class="volume-message">
                <p class="volume-message__title">
                    <strong>Cálculo por Período Fixo</strong>
                </p>

                <p>
                    O volume é calculado pela diferença entre as medições
                    nas datas inicial e final selecionadas.
                </p>

                <p>
                    A precisão depende da existência de reportes próximos
                    aos limites do período.
                    Períodos menores são mais sensíveis à frequência
                    de comunicação.
                </p>
            </div>
        `
    }
};

export function getVolumeChartGroupByMessage(groupBy) {
    if (!groupBy) {
        return { title: '', message: '' };
    }

    const key = groupBy.toLowerCase();
    const normalizedKey = GROUP_BY_ALIASES[key] || key;

    return VOLUME_MESSAGES[normalizedKey] || {
        title: '',
        message: ''
    };
}
